import { render, staticRenderFns } from "./labour-groups.vue?vue&type=template&id=3572860e"
import script from "./labour-groups.vue?vue&type=script&lang=js"
export * from "./labour-groups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports